import { memo, useCallback, useState } from 'react';
import { Button, Table } from 'antd';
import { JustRightHeightModal } from 'components/styled/scoped';
import { useTranslate } from '@tolgee/react';
import { css } from '@emotion/css';
import dayjs from 'lib/dayjs';
import { useGetUploadRecord } from './connect';
import download from 'utils/download';

type UploadRecordProps = {
  visible: boolean;
  onCancel: () => void;
};
const UploadRecord = memo((props: UploadRecordProps) => {
  const { visible, onCancel } = props;
  const { t } = useTranslate();
  const { data, loading } = useGetUploadRecord();

  return (
    <JustRightHeightModal
      title={t('outofstock_import_record')}
      width={828}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      centered
      className={css`
        .ant-modal-body {
          padding: 15px 22px !important;
          margin: 0 !important;
        }
      `}
    >
      <div>
        <div className="leading-[20px] text-[#84868c] mb-[12px]">
          {t('outofstock_import_recent_record', { x: 30 })}
        </div>

        <Table<OutofStock.UploadRecord>
          dataSource={data || []}
          loading={loading}
          pagination={{
            total: data?.length || 0,
          }}
          columns={[
            {
              title: t('ViewsChat.文件名'),
              dataIndex: 'fileName',
              key: 'fileName',
            },
            {
              title: t('aeoverview.时间'),
              dataIndex: 'createTimeMs',
              key: 'createTimeMs',
              render: (value) => {
                return dayjs(Number(value)).format('YYYY-MM-DD HH:mm:ss');
              },
            },
            {
              title: t('outofstock_import_record_success_count'),
              dataIndex: 'successCount',
              key: 'successCount',
            },
            {
              title: t('outofstock_import_record_failed_count'),
              dataIndex: 'errorCount',
              key: 'errorCount',
            },
            {
              title: t('voucher.操作人'),
              dataIndex: 'operateUserName',
              key: 'operateUserName',
            },
            {
              title: t('操作'),
              key: 'action',
              fixed: 'right',
              width: 130,
              render: (_, record) => {
                return (
                  <div>
                    <Button
                      onClick={() => {
                        download(record.resultUrl);
                      }}
                      className="!pl-[0]"
                      type="link"
                    >
                      {t('outofstock_import_record_download')}
                    </Button>
                  </div>
                );
              },
            },
          ]}
        ></Table>
      </div>
    </JustRightHeightModal>
  );
});

const useUploadRecord = () => {
  const [visible, setVisible] = useState(false);
  const open = useCallback(() => {
    setVisible(true);
  }, []);

  const close = useCallback(() => {
    setVisible(false);
  }, []);

  const instance = visible && <UploadRecord visible={visible} onCancel={close} />;

  return [open, instance] as const;
};

export default useUploadRecord;
